module.exports = __webpack_public_path__ + "static/media/female_avatar.55b48a99.svg";